import { useTranslation } from "react-i18next";
import EditRating from "../../../components/EditRating";
import { BetweenDates } from "../AdvanceSearch/Betweendates";
import { useEffect, useState } from "react";
import { InterviewService } from "../../../services/InterviewService";
import { translateAndSortAscendant } from "../../../common/helper";
import moment from "moment/moment";

import { JobRoleDetailService } from "../../../services/JobRoleDetailService";
import { TechRoleService } from "../../../services/TechRoleService";
import { useSideDrawerSearch } from "../../../components/SideDrawerSearch";
import JobRoleDetails from "../../../components/JobRoleDetailsTree/JobRoleDetails";

export default function FilterForm({ searchObject, setSearchObject }) {
  const [recruiters, setRecruiters] = useState([]);
  const [managers, setManagers] = useState([]);
  const [techAreas, setTechAreas] = useState([]);
  const [techRoles, setTechRoles] = useState([]);
  const { onChangeFilters } = useSideDrawerSearch();
  useEffect(() => {
    InterviewService.getRecruitersList().then((data) =>
      setRecruiters(translateAndSortAscendant(data, "nickname"))
    );
    InterviewService.GetManagerList().then((data) =>
      setManagers(translateAndSortAscendant(data, "nickname"))
    );
    JobRoleDetailService.getAllTechAreas().then((data) =>
      setTechAreas(translateAndSortAscendant(data, "description"))
    );
  }, []);

  useEffect(() => {
    if (searchObject.techAreaId) {
      JobRoleDetailService.getAllTechRoles(
        searchObject.techAreaId
      ).then((data) => setTechRoles(data));
    } else {
      TechRoleService.getAllTechRoles().then((data) => setTechRoles(data));
    }
  }, [searchObject.techAreaId]);

  let { t } = useTranslation();
  function setRating(rating) {
    setSearchObject({ ...searchObject, rating: rating });
    onChangeFilters("rating", "rating: " + rating);
  }

  function onChange({ target }) {
    if (target.name === "techAreaId") {
      setSearchObject({
        ...searchObject,
        [target.name]: target.value,
        techRoleId: ""
      });
      onChangeFilters(
        [target.name],
        techAreas.find((x) => x.id === Number(target.value))?.description
      );
    } else if (target.name === "techRoleId") {
      setSearchObject({
        ...searchObject,
        [target.name]: target.value
      });
      onChangeFilters(
        [target.name],
        techRoles.find((x) => x.id == Number(target.value))?.description
      );
    } else {
      setSearchObject({ ...searchObject, [target.name]: target.value });
      onChangeFilters([target.name], target.value);
    }
  }

  function onChangeDate(_searchObject) {
    setSearchObject(_searchObject);
    if (_searchObject.requestDateStart)
      onChangeFilters(
        "requestDateStart",

        "Request Start Date:" +
          moment(_searchObject.requestDateStart).format("DD/MM/YYYY")
      );
    if (_searchObject.requestDateEnd)
      onChangeFilters(
        "requestDateEnd",

        "Request End Date:" +
          moment(_searchObject.requestDateEnd).format("DD/MM/YYYY")
      );
    if (_searchObject.lastInterviewDateStart)
      onChangeFilters(
        "lastInterviewDateStart",

        "Last Interview Start Date:" +
          moment(_searchObject.lastInterviewDateStart).format("DD/MM/YYYY")
      );
    if (_searchObject.lastInterviewDateEnd)
      onChangeFilters(
        "lastInterviewDateEnd",

        "Last Interview End Date:" +
          moment(_searchObject.lastInterviewDateEnd).format("DD/MM/YYYY")
      );
  }
  return (
    <>
      <div className="form-group mt-2">
        <label className="form-label">{t("Description")} </label>
        <input
          type="text"
          className="form-control"
          value={searchObject.description || ""}
          placeholder={t("Description")}
          name="description"
          onChange={onChange}
        />
      </div>

      <div className="form-group mt-2">
        <label className="form-label">{t("Email")} </label>
        <input
          type="text"
          className="form-control"
          value={searchObject.candidateEmail || ""}
          placeholder={t("Candidate Email")}
          name="candidateEmail"
          onChange={onChange}
        />
      </div>
      <div className="form-group mt-2">
        <label className="form-label">{t("Recruiter")} </label>
        <select
          className="form-select"
          name="recruiter"
          onChange={onChange}
          required
          value={searchObject.recruiter || ""}
        >
          <option value="" selected>
            {t("Select recruiter..")}
          </option>
          {recruiters.map((recruiter) => (
            <option key={recruiter.id} value={recruiter.nickname}>
              {recruiter.nickname}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group mt-2">
        <label className="form-label">{t("Manager")} </label>
        <select
          value={searchObject.manager || ""}
          onChange={onChange}
          className="form-select"
          placeholder={t("manager")}
          name="manager"
          required
        >
          <option value="" selected>
            {t("Select manager..")}
          </option>
          {managers.map((manager) => (
            <option key={manager.id} value={manager.nickname}>
              {manager.nickname}
            </option>
          ))}
        </select>
      </div>

      <JobRoleDetails
        onChange={onChange}
        searchObject={searchObject}
        techAreas={techAreas}
        techRoles={techRoles}
      />
      {/* <div className="form-group mt-2">
        <label className="form-label">{t("Professional Category")}</label>
        <select
          onChange={onChange}
          value={searchObject.techAreaId || ""}
          className="form-select"
          placeholder={t("Professional category")}
          name="techAreaId"
          required
        >
          <option value="" selected>
            {t("Select a item..")}
          </option>
          {techAreas.map((job) => (
            <option key={job.id} value={job.id}>
              {job.description}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group mt-2">
        <label className="form-label">{t("Role")}</label>
        <select
          onChange={onChange}
          value={searchObject.techRoleId || ""}
          className="form-select"
          placeholder={t("Select Role")}
          name="techRoleId"
          required
        >
          <option value="" selected>
            {t("Select a Item..")}
          </option>
          {techRoles.map((job) => (
            <option key={job.id} value={job.id}>
              {job.description}
            </option>
          ))}
        </select>
      </div> */}
      <div className="form-group mt-2">
        <label className="form-label">{t("request")}</label>
        <BetweenDates
          setObeject={onChangeDate}
          dateStartField="requestDateStart"
          dateEndField="requestDateEnd"
          dateObject={searchObject}
          placeholderStart={t("Requested on start")}
          placeholderEnd={t("Requested on end")}
        />
      </div>

      <div className="form-group mt-2">
        <label className="form-label">{t("Last Interview")} </label>
        <BetweenDates
          setObeject={onChangeDate}
          dateStartField="lastInterviewDateStart"
          dateEndField="lastInterviewDateEnd"
          dateObject={searchObject}
          placeholderStart={t("Last interviewed start")}
          placeholderEnd={t("Last interviewed end")}
        />
      </div>
      <div className="form-group mt-2">
        <label className="form-label">{t("Rating")} </label>

        <EditRating ratingObj={searchObject} onChange={setRating} />
      </div>
    </>
  );
}
